export enum RemoteType {
    Remotemöglich = "Remote / Home Office möglich",
    HomeOfficemöglich = "Ausschließlich Remote / Home Office"
};
